import { Component, OnInit } from '@angular/core';
import { GuestDataComponent } from 'src/app/shared/components/guest-data/guest-data.component';
import { ActivityTabs } from 'src/app/shared/constants/commonenums';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-activity-additionalguest',
    templateUrl: './activity-additionalguest.component.html',
    styleUrls: ['./activity-additionalguest.component.scss'],
    standalone: false
})
export class ActivityAdditionalguestComponent implements OnInit {
  currentComponent = GuestDataComponent;
  selectedIndex: any;
  additonalGuestIndex:ActivityTabs = ActivityTabs.AdditionalGuest;
  constructor(private gs: GuestService) { 
    this.gs.TabChange$.subscribe(data => {
      this.selectedIndex = data;
    })
  }

  ngOnInit(): void {
    return;
  }

}

